export enum ResponseType {
  SUCCESS = 200,
}
